<section class="pt-2 ">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>{{ isFormView ? 'Editar detalle de documento soporte' : 'Detalle de documento soporte' }}</h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
          <app-custom-modal #selectArticle [label]="'Nuevo'" [header]="'Selección de Articulos'"
            [inputs$]="inputsForArticlesSelect$" [output$]="output$" [children]="component"
            (selectedItems)="handleSelectedItems($event)" hidden></app-custom-modal>
          <app-custom-button tom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledButton"
            (onClick)="openModal()" [width]="'7rem'"></app-custom-button>
        </div>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-document-support-detail [documentSupportDetailContract]="documentSupportDetail"
          [documentSupportModel]="documentSupportModel" [disabled]="disabledDetail"
          (updateListDetail)="getUpdateListDetail()" (isFormView)="getFormView($event)">
        </app-register-document-support-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]="!disabledActions" [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getDocumentSupportDetailsByDocumentSupport()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>